<template>
    <div class="welcome-video">
        <video id="welcome-video" v-if="!loading" autoplay muted loop playsinline v-on:canplay="canPlayVideo()">
            <source :src="video.url" :type="video.type">
        </video>
        <div class="text">
            <p>Archaeology</p>
            <p>Looking Forward</p>
        </div>
    </div>
</template>

<script>
    import * as contentHelper from "../../helpers/content.helper";
    import anime from "animejs";

    export default {
        name: "WelcomeVideo",
        data() {
          return {
              loading: true,
              video: {
                  url: null,
                  type: null
              }
          }
        },
        mounted() {
            contentHelper.client.getAsset('6IKG7ILRd02t1Al9gtCVQu')
                .then((asset) => {
                    this.video.url = asset.fields.file.url;
                    this.video.type = asset.fields.file.contentType;
                    this.loading = false;

                });
        },
        methods: {
            canPlayVideo() {
                const element = document.getElementById('welcome-video');

                anime({
                    targets: element,
                    opacity: 1,
                    duration: 2000,
                    easing: 'easeOutQuad'
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/styles/global';

    .welcome-video {
        margin-top: 10em;
        height: 40em;
        overflow: hidden;
        position: relative;
        background-color: black;

        .welcome-img {
            width: 100%;
            height: 100%;
            // IE doesn't support object-fit
            object-fit: cover;
        }

        .text {
            position: absolute;
            color: white;
            font-family: "Work Sans", sans-serif;
            text-transform: uppercase;
            font-size: 4em;
            font-weight: 600;
            user-select: none;

            margin: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            p {
                margin-block-start: 0em;
                margin-block-end: 0em;
            }
        }
    }

    #welcome-video {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        object-fit: cover;
        object-position: center;

        opacity: 0;

    }

    @media only screen and (max-width: 1650px) {
        .welcome-video {
            .text {
                font-size: 3em;
            }
        }
    }

    @media only screen and (max-width: 960px) {
        .welcome-video {
            .text {
                font-size: 2.5em;
            }
        }
    }

    @media only screen and (max-width: 805px) {
        .welcome-video {
            .text {
                font-size: 2em;
            }
        }
    }

    @media only screen and (max-width: 767px) {
        .welcome-video {
            margin-top: $mobile-bar-height;
            height: 100%;

            .text {
                font-size: 1.5em;
            }
        }
        #welcome-video {
            width: 100%;
            height: 100%;
            position: relative;
        }
    }

    @media only screen and (max-width: 605px) {
        .welcome-video {
            .text {
                font-size: 1.2em;
            }
        }
    }

</style>
